import React, { Component } from 'react';
import Vex from 'vexflow';
import './App.css';

const mainOptions = ['bass', 'treble', 'both'];
let question;

function getCount() {
  return null;
}
  
function getQuestion(i) {
  let clef1, clef2;

  const clef = mainOptions[getRand(0, 2)];
  if (clef === 'treble') {
    clef1 = clef2 = clef;
    question = getSameClef('A3', 'C6');
  } else if (clef === 'bass') {
    clef1 = clef2 = clef;
    question = getSameClef('C2', 'E4');
  } else {
    clef1 = 'treble';
    clef2 = 'bass';
    question = getBothClefs();
  }

  console.log(question);
  
  const vf = new Vex.Flow.Factory({
    renderer: {elementId: '_vex', width: 150, height: 250}
  });
  const score = vf.EasyScore();
  const system = vf.System();
  
  try {
    system.addStave({
      voices: [
        score.voice(score.notes(question.high + '/w', {clef: clef1})),
      ]
    }).addClef(clef1);

    system.addStave({
      voices: [
        score.voice(score.notes(question.low + '/w', {clef: clef2})),
      ]
    }).addClef(clef2);

    system.addConnector();
    vf.draw();    
  } catch(_){
    return getQuestion();
  }
  return vf.context.svg;
}

const intervalFriend = [
  '',
  'a unison',
  'a second',
  'a third',
  'a fourth',
  'a fifth',
  'a sixth',
  'a seventh',
  'an octave',
];

function getAnswer(i) {
  return (
    <div>
    <p>{question.low} to {question.high} is {intervalFriend[question.i]}</p>
    </div>
  );
}

function getAllNotes() {
  const names = 'C,C#/Db,D,D#/Eb,E,F,F#/Gb,G,G#/Ab,A,A#/Bb,B'.split(',');
  let octave = 0;
  let idx = 0;
  const notes = [];
  for (let midi = 24; midi < 127; midi++) {
    if (idx === 12) {
      idx = 0;
      octave++;
    }
    notes[midi] = (names[idx++] + octave).replace('/', '' + octave + '/');
  }
  return notes;
}

const notesLookup = getAllNotes();

function getRange(start, end, noAccidentals) {
  const res = notesLookup.slice(notesLookup.indexOf(start), notesLookup.indexOf(end) + 1);
  if (!noAccidentals) {
    return res;
  }
  return res.filter(v => !v.includes('/'))
}


function getRand(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getSameClef(start, end) {
  const i = getRand(1, 8);
  const range = getRange(start, end, true);
  const low = range[getRand(0, range.length - 1 - i)];
  const high = range[range.indexOf(low) + i - 1];
  return {i, low, high};
}

function getBothClefs() {
  const i = getRand(1, 8);
  const belowC4 = getRand(0, i);
  const range = getRange('C3', 'C5', true);
  const c4index = range.indexOf('C4');
  const low = range[c4index - belowC4];
  const high = range[range.indexOf(low) + i - 1];
  return {i, low, high};
}

// the actual quiz is done, boring stuff follows...

class App extends Component {
  constructor() {
    super();
    this.state = {
      question: getQuestion(1),
      answer: getAnswer(1),
      total: getCount(),
      i: 1,
    };
    window.addEventListener('keydown', (e) => {
      // right arrow
      if (e.keyCode === 39 || e.charCode === 39) {
        e.preventDefault();
        this.nextQuestion();
      }
      // n and N
      if (e.keyCode === 110 || e.charCode === 110 || e.keyCode === 78 || e.charCode === 78) {
        e.preventDefault();
        this.nextQuestion();
      }
    });
  }
  
  nextQuestion() {
    this.setState({
      question: getQuestion(this.state.i + 1),
      answer: getAnswer(this.state.i + 1),
      i: this.state.i + 1,
    });
  }
  
  render() {
    return (
      <div>
        {
          this.state.total 
            ? <Count i={this.state.i} total={this.state.total} />
            : null
        }
        <Flashcard
          id={this.state.i}
          question={this.state.question}
          answer={this.state.answer}
        />
        {' '}        
        {
          (this.state.total && this.state.i >= this.state.total)
            ? null
            : <button 
                className="nextButton" 
                onClick={this.nextQuestion.bind(this)}>
                next...
              </button>
        }
      </div>
    );
  }
}

class Flashcard extends Component {

  constructor(props) {
    super();
    this.state = {
      reveal: false,
      id: props.id,
    };
    window.addEventListener('keydown', (e) => {
      // arrows
      if (e.keyCode === 38 || e.charCode === 38 || e.keyCode === 40 || e.charCode === 40) {
        this.flip();
      }
      // f and F
      if (e.keyCode === 102 || e.charCode === 102 || e.keyCode === 70 || e.charCode === 70) {
        this.flip();
      }
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.id !== state.id) {
      return {
        reveal: false,
        id: props.id,
      };
    }
    return null;
  }

  flip() {
    this.setState({
      reveal: !this.state.reveal,
    });
  }

  render() {
    const className = "card flip-container" + (this.state.reveal ? ' flip' : '');
    return (
      <div><center>
        <div className={className} onClick={this.flip.bind(this)}>
          <div className="flipper">
            <div className="front" style={{display: this.state.reveal ? 'none' : ''}}>
              <div dangerouslySetInnerHTML={{__html: this.props.question.outerHTML}} />
            </div>
            <div className="back" style={{display: this.state.reveal ? '' : 'none'}}>
              {this.props.answer}
            </div>
          </div>
        </div>
        <button className="answerButton" onClick={this.flip.bind(this)}>flip</button>
      </center></div>
    );
  }
}

const Count = ({i, total}) =>
  <div>
    Question {i} / {total}
  </div>;

export default App;




// WEBPACK FOOTER //
// ./src/App.js